import "../assests/CSS/GTMcomponent6.css";
import toolkitData from "./data";

const GTMcomponent6 = () => {
  return (
    <div className="gtm6-container">
      <h2 className="gtm6-title">
        What’s Inside <br /> the Toolkit?
      </h2>

      <div className="gtm6-cards">
        {toolkitData.map((item) => (
          <div className="gtm6-card" key={item.id}>
            <div className="gtm6-header">
              <img src={item.icon} alt={item.title} className="gtm6-icon" />
              <h3>{item.title}</h3>
            </div>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GTMcomponent6;


